import {
  BookingType,
  NotSerializedBookingMode
} from "../../../features/Booking-Form/typings/booking-inputs";
import type { TeamMember } from "../../../features/Booking-Form/typings/team-member";
import {
  checkCurrentUser,
  getFirstTeamWorkplaceSeatUserIndex,
  getFirstVisitorWorkplaceSeatUserIndex
} from "./form.functions";

/**
 * Initial / synced index of {@link usersBookedFor} for workplace floor-plan selection
 * (visitor unbooked guest first, then team rules, else single-booker desk gap).
 */
export function getFormWorkplaceInitialUserIndex(
  mode: NotSerializedBookingMode,
  usersBookedFor: TeamMember[] | undefined
): number {
  const list = usersBookedFor ?? [];
  if (list.length === 0) {
    return 0;
  }

  if (mode === BookingType.VISITOR) {
    return getFirstVisitorWorkplaceSeatUserIndex(list);
  }

  if (mode === BookingType.TEAM) {
    return getFirstTeamWorkplaceSeatUserIndex(list);
  }

  return checkCurrentUser(list);
}
